export default __webpack_public_path__ + "static/pusher-logo-white-744523dbb6e352bf8dd2d95d123c86e8.svg";